import React from "react";

const StartButton = ({ onClick }) => (
  <a href='/start' onClick={onClick} className='start-button'>
    START
  </a>
);

export default StartButton;
